module.exports = __webpack_public_path__ + "img/SHEnterpriseManage.c581e231.svg";